<template>
<div class="publicwelpro">
	<header-view :tabsign='1'></header-view>

	<div class="con_tent">
		<div class="cont-r"></div>

		<div class="concar w12 min-h">
			<div class="toptitle">
				<div class="left_c">
					<div class="redcon"></div>
					<span>公益项目</span>
				</div>
				<div class="right_c">
					<div class="searchcon">
						 <input class="inputa" :class="searchv?'':'plac'" @input="changeinput" v-model="searchv" placeholder="请输入"/>
						 <el-image fit='cover' class="imgcon" :src="require('../../assets/newimg/searchimg.png')" alt=""
						 @click="changeinput"></el-image>
					</div>
				</div>
			</div>

			<div class="lista">
				  <div v-for="(item, index) in typelist" class="listsignle"
				  @click="changetab(index)">
					  <div :class="index == indexsign?'signlea_cur':'signlea'">
							<div>{{item.title||''}}</div>
					  </div>
					  <div :class="index == indexsign?'':'linecon'"></div>
				  </div>
			</div>

			<div class="dataNavList">
				<div class="dataNavListItem" v-for="(item,index) in Institutional" :key="index"
				@click="toprojectDetails(index,item)">
					<div class="imgcollection">
						<div class="imgcon">
							<el-image fit='cover' :src="imageUrl + item.indexPic" :title="item.title" ></el-image>
						</div>
						<el-image fit='cover' v-if="item.donationState == 1" class="fundraisimg"
						:src="require('../../assets/newimg/fundraisimg@2x.png')" alt="" ></el-image>
					</div>
					<div class="infocon">
						<div class="title" :title="item.title">{{item.title?item.title.substring(0,20):'-'}}</div>
						<div class="mechan">执行机构：{{item.reciveDept?item.reciveDept.substring(0,20):'-'}}</div>
						<div class="time">资助时间：{{item.startDate || '-'}}-{{item.endDate || '-'}}</div>
						<div class="addr">资助地点：{{item.contributionFlow?item.contributionFlow.substring(0,20):'-'}}</div>
					</div>
					<div class="donatebtn" v-if="item.donationState == 1">我要捐助</div>
					<div class="seebtn" v-if="item.donationState == 0">查看详情</div>
				</div>

			</div>

		</div>

		<div class="cont-r">
			<div class="fitbox" @click="choice()">
				<div class="label">非限定性项目捐款</div>
			</div>
		</div>
	</div>

	<zhini-pagination :key="componentKey"
		class="zhini-pagination"
		:currentPage="pageNo"
		:totalPage="totalPage"
		@pageNum="pageNum"
	></zhini-pagination>

</div>

</template>

<script>

import zhiniPagination from "../../components/zhini-pagination.vue";
export default {
  components: {
	  zhiniPagination
  },
  data: function() {
		return {
			Institutional: "",
			pageNo: 1,
			pageSize: 6,
			totalPage: 0,
			title: "",
			ifshow:false,

			indexsign:0,
			typelist:[],
			searchv:"",
			componentKey: 0,        //用于强制刷新

		};
  },
  mounted() {
	  this.indexsign=0;
	  this.getSys()
	  this.changeinput();
  },
  methods: {
	getSys(){//
      this.httpGet("web/dict/getDictItems/fundraising_state").then(res => {
        if(res.success){
          this.typelist = res.result;
		  this.typelist.unshift({value: "", text: "全部", title: "全部"})
        }
      });
    },
	choice() {//?id=id=1553996159910019074&title=救助流浪狗
       this.$router.push({ path: "/payment"});
    },
	//搜索
	changeinput(){
		this.pageNo = 1;
	  	this.getjzpageList();
	},

	//变化tab
	changetab(index){
		this.indexsign = index;
		this.pageNo = 1;
		this.totalPage = 0;
		this.componentKey += 1;
		this.getjzpageList();
	},

	getjzpageList() {
		  var that = this;
		  var obj = {
				pageNo: this.pageNo,
				pageSize: this.pageSize,
				title: this.searchv,
				column:"startDate",
				order:"desc",
		  };
		  if(this.indexsign>0){
			  obj.fundraisingState =this.typelist[this.indexsign].value
		  }else{
			  delete obj.fundraisingState
		  }
		//   if(this.indexsign == 1){
		// 	  obj.fundraisingState = "0"
		//   }else if(this.indexsign == 2){
		// 	  obj.fundraisingState = "2"
		//   }

		  this.httpGet("web/thpDonationActivity/queryPageList", obj).then(res => {
			// console.log(res.result);
			// that.$store.commit("upProject", res.result.records);
			that.totalPage = Math.ceil(res.result.total / that.pageSize);
			that.Institutional = res.result.records;
			if(that.Institutional.length == 0){
				that.ifshow = true;
			}else{
				that.ifshow = false;
			}
		  });

		  window.pageYOffset = 0;
		  document.documentElement.scrollTop = 0;
		  document.body.scrollTop = 0;
	},

	pageNum(e) {
		window.pageYOffset = 0;
		document.documentElement.scrollTop = 0;
		document.body.scrollTop = 0;
		this.pageNo = e;
		this.getjzpageList();
	},

	//跳转捐赠
	toprojectDetails(indexsign,item){
		this.$router.push({ path: '/projectDetails', query: {index:indexsign,id:item.id} });
	},


  },



};

</script>

<style scoped=" scoped" lang="scss">
::-webkit-scrollbar { width: 0 !important }
.publicwelpro{
	.con_tent{
		margin-top: 100px;
		display: flex;
		justify-content: center;
		align-items: stretch;
		position: relative;
		color: #333333;
		// position: relative;
		.cont-r{
			// overflow: hidden;
			width: calc(50% - 600px);
			position: relative;
		}
		.fitbox{
			cursor:pointer;
			position: absolute;
			top: 15%;
			// margin-left: 61px;
			// left: 16.67%;
			width: 112px;
			height: 106px;
			background: #D30A0F url('./../../assets/index/hxjz.png') no-repeat;
			background-size: contain;
			display: flex;
			align-items: flex-end;
			justify-content: center;
			.label{
				color: #ffffff;
				padding: 0px 20px;
				font-size: 10px;
				margin-bottom: 5px;
				text-align: center;
				box-sizing: border-box;
			}
		}
		@media only screen and (max-width: 1170px){
			.fitbox{
				left: 0px;
			}
		}
	}
	.concar {
		background: #ffffff;

		.toptitle{
			height:60px;
			border-bottom: 1px solid #ededed;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.left_c{
				display: flex;
				align-items: center;
				font-size: 25px;
				font-weight: 400;
				color: #E61F26;
				.redcon{
					width: 5px;
					height: 20px;
					background: #E70012;
					margin-right: 20px;
				}
			}
			.right_c{
				.searchcon{
					height: 40px;
					line-height: 40px;
					width: 268px;
					border: 1px solid #F1F1F1;
					border-radius: 15px;
					padding-left: 20px;
					padding-right: 20px;
					display: flex;
					align-items: center;
					justify-content: space-between;
					.inputa{
						font-size: 14px;
						height: 100%;
					}
					.imgcon{
						height:18px;
						width: 18px;
					}
				}
			}
		}

		.lista{
			 margin-top: 20px;
			 width: 100%;
			 height: 37px;
			 background: #FBFBFB;
			 display: flex;
			 align-items: center;
			 .listsignle{
				display: flex;
				align-items: center;
			 }
			 .signlea,.signlea_cur{
				width: 107px;
				height: 37px;
				line-height: 37px;
				text-align: center;
				font-size: 16px;
				cursor: pointer;
			 }
			 .signlea{
				color: #666666;
			 }
			 .signlea_cur{
				background: #E70012;
				color: #FFFFFF;
			 }
			 .linecon{
				 width: 1px;
				 height: 17px;
				 background: #666666;
				 opacity: 0.3;
			 }
		}

		.dataNavList {
			 display: flex;
			 align-items: center;
			 flex-wrap: wrap;
			 box-sizing: border-box;
			//  height: 453px;
			 width: 1200px;
			 .dataNavListItem:hover{
				transform:scale(1.05,1.05);
				transition: transform 1s;
			 }
			 .dataNavListItem{
				 // border: 1px solid red;
				 border: 1px solid #EEEEEE;
				 cursor: pointer;
				 height: 423px;
				 //每个菜单项的宽度要固定，不然move值无法计算，当然也可以通过其他方法来设置以适应自己的表格
				 width: 560px;
				 font-size:16px;
				 margin-right:40px;
				 margin-top:40px;
				 .imgcollection{
					  height: 240px;
					 .imgcon{
						 width: 100%;
						 height: 220px;
						 overflow: hidden;
						 .el-image{
							width: 100%;
							height: 220px;
						 }
					 }
					 .fundraisimg{
						 position: relative;
						 z-index: 5;
						 width: 44px;
						 height: 50px;
						 top: -230px;
						 left: 40px;
					 }
				 }

				 .infocon{
					margin-left: 40px;
					font-size:16px;
					font-weight: 400;
					color: #666666;
					.title{
						font-size:18px;
						color: #333333;
						height: 50px;
						line-height: 50px;
					}
					.mechan,.time,.addr{
						height: 35px;
						line-height: 35px;
					}
				 }
				 .donatebtn,.seebtn{
					position: relative;
					z-index: 5;
					width: 96px;
					height:30px;
					line-height:30px;
					text-align: center;
					border-radius: 15px;
					bottom: 50px;
					left: 440px;
					font-size: 16px;
					font-weight: 400;
				 }
				 .donatebtn{
					color: #FFFFFF;
					background: #E41E15;
				 }
				 .seebtn{
					color: #E61F26;
					border: 1px solid #E41E15;
				 }

			 }


		}




	}

	.zhini-pagination {
	  position:relative;
	  top:0px;
	  width: 100%;
	  left: 0;
	}

}

</style>
